import React from 'react';

import { InvitationRedirect } from 'components/registration/invitation-code/InvitationRedirect';

export const InvitationHandlerPage: React.FC = () => {
    return <InvitationRedirect />;
};
